import React from "react";
import intl from "react-intl-universal";

export function BlackModal() {

    return (
        <>
            <section className="pt-medium pb-medium dark-main-color">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">

                            <div className="cta-box cta-box-2-cols">
                                <div className="cta-box-text">
                                    <h1 style={{fontSize: '32px'}}>
                                        ENDO ONE SOLUTION
                                    </h1>
                                    <p style={{fontSize: '24px'}}>
                                        {intl.get('slogon')}
                                    </p>

                                </div>
                                <div className="cta-box-btn">
                                    <a className="btn default large" title=""
                                       href="tel:31062832"
                                       target="blank">
                                        <i className="icon-flash"></i> Contact Us
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
